<template funtional>
  <div v-if="!$store.getters.atLeastFiveVisits" class="flex justify-center text-center">
    <vx-card cardBackground="#ffffff" class="mx-8 mt-4 shadow-none border border-solid">

      <template v-slot:title>
        <h2 class="font-bold">{{title}}</h2>
      </template>

      <slot></slot>

    </vx-card>
  </div>
</template>

<script>
export default {
  props: ['title'],
}
</script>
